/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type ForcJournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import Sections from "./sections";

interface Signature {
  Args: {
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default class CtcaeCustomBaseConsultForm extends Component<Signature> {
  Sections = Sections;
}
